import { z } from 'zod';
import { Pegasus } from '../pegasus.js';
export const shippingClaimLookup = z.object({
    slaAlerts: z.array(Pegasus.eventSpcSlaNotification.shape.params.shape.alert),
    reorderLocations: z.array(z.object({
        id: z.number(),
        name: z.string(),
        idFromPlatform: z.string(),
    })),
    // ? were the locations provider by returning all configured in DB or limited by an automation
    reorderLocationProvider: z.union([z.literal('all'), z.literal('automation')]),
    minInventoryAvailable: z.number(),
    isFinalizeBlocked: z.boolean(),
    isGiftCardEnabled: z.boolean(),
    reorderShipping: Pegasus.eventSpcReorderShipping.shape.params.optional(),
    resolutionMethods: Pegasus.eventSpcAllowedResolutions.shape.params.shape
        .shippingClaimResolutionMethods,
});
//# sourceMappingURL=shippingClaimAutomation.js.map